import { xs_languageCode } from "../..";
import { splitHandicap } from "../splitHandicap";
import { invertSign } from "./invertSign";
import { getGenericHandicapDescriptionPart } from "./getGenericHandicapDescriptionPart";


//NOTA BENE: PER FAR SI CHE IL TIPO 55 SIA MOSTRATO COME (RISULTATO) +HANDICAP (ES: (1:2) +4) LA DESCRIZIONE
// IMPOSTATA DA CMS DEVE AVERE UN + PRIMA DELL'HANDICAP 3 SENZA SPAZI. SE IL VALORE E' NEGATIVO, MI PREOCCUPERO' SOSTITUIRE IL + CON STRINGA VUOTA
export function parseHandicap(desc, handicap, tipoHandicap, draws, additionalData, handleAsianHandicap = false, handicapInfo = null, hndTableSourceDesc = null) {
   // stringa di test per provare l'info 55
   // hndTableSourceDesc = 'ENTRAMBE LE SQUADRE ALMENO @@H1@@ GOAL, @@H2@@ CARTELLINI, +@@H3@@ ANGOLI';
    const result = splitHandicap(handicap, tipoHandicap, draws, additionalData, xs_languageCode, handicapInfo);
    if (tipoHandicap === 23 && handleAsianHandicap) {
        result.info1 = invertSign(result.info1);
    }
    let placePlusForHandicap55 = false;
    
    const checkDesc = desc.length > 0? desc : hndTableSourceDesc;
    if(tipoHandicap == 55 && (checkDesc?.includes('+@@H3@@') || checkDesc?.includes('+{{H3}}'))){
    	const toSplit = checkDesc.includes('+@@H3@@')? '+@@H3@@' : '+{{H3}}';
    	placePlusForHandicap55 = true;
    	if(result.info3 < 0 && desc.length > 0){
			// rimuovo il +, in modo che sia visibile solo il - dell'intero
			const toSubst = desc.includes('+@@H3@@')? '@@H3@@' : '{{H3}}';
			desc = desc.replace(toSplit, toSubst);
		}
    }
    let toAppend = '';
    if (desc.includes('@@')) {
        if (handicap == 0) {
            desc = desc.replace('@@H1@@', getGenericHandicapDescriptionPart(0, handicap, 1))
            .replace('@@H2@@', getGenericHandicapDescriptionPart(0, handicap, 2))
            .replace('@@H3@@', (placePlusForHandicap55?  "+" : "") + getGenericHandicapDescriptionPart(0, handicap, 3))
            .replace('@@H4@@', getGenericHandicapDescriptionPart(0, handicap, 4))
            .replace('@@H5@@', getGenericHandicapDescriptionPart(0, handicap, 5))
            .replace('@@H6@@', getGenericHandicapDescriptionPart(0, handicap, 6))
            .replace('@@H7@@', getGenericHandicapDescriptionPart(0, handicap, 7))
            .replace('@@H8@@', getGenericHandicapDescriptionPart(0, handicap, 8));
        } else {
            desc = desc.replace('@@H1@@', result.info1)
            .replace('@@H2@@', result.info2)
            .replace('@@H3@@', result.info3)
            .replace('@@H4@@', result.info4)
            .replace('@@H5@@', result.info5)
            .replace('@@H6@@', result.info6)
            .replace('@@H7@@', result.info7)
            .replace('@@H8@@', result.info8);
            if (tipoHandicap === 38 && !desc.includes(result.info2)) {
                //NO!!!! desc += ' '+result.info2;
            } // TODO: se la vogliono nella descrizione, la specificano da CMS tramite placeholder @@H2@@
        }
    } else if (desc.includes('{{')) {
        desc = desc.replace('{{H1}}', result.info1)
                    .replace('{{H2}}', result.info2)
                    .replace('{{H3}}', result.info3)
                    .replace('{{H4}}', result.info4)
                    .replace('{{H5}}', result.info5)
                    .replace('{{H6}}', result.info6)
                    .replace('{{H7}}', result.info7)
                    .replace('{{H8}}', result.info8);
    } else if (desc.indexOf(':') === -1 && handicap !== '0') {
        function appender(spaceChar) {
            for (let i = 0; i < result.infoCalcolate; i++) {
                const res = result[`info${i + 1}`];
                
                if (i > 0) {
                    toAppend += spaceChar;
                }
                if (res?.dia != null) {
                    toAppend += res.dia;
                } else if (res != null) {
                    toAppend += res;
                }
            }
        }

        if (desc === '') {
            // sto calcolando la descrizione da mostrare nella tabella HCP
            if (tipoHandicap == 64 || (tipoHandicap == 55 && placePlusForHandicap55)) {
                const baseSettlement = result.info1 === 0 && result.info2 === 0? "" :
                "(" + result.info1 + ':' + result.info2 + ") ";
                toAppend = toAppend + baseSettlement + ((placePlusForHandicap55? "+" : "") + result.info3);
            } else if (tipoHandicap === 70) {
                const baseSettlement = result.info2 === 0 && result.info3 === 0? "" :
                " (" + result.info2 + ':' + result.info3 + ")";
                toAppend = toAppend + result.info1 + baseSettlement;
            } else if (tipoHandicap === 39) {
                toAppend = `${result.info1 / 100}, ${result.info2 / 100}`;
            } else if(tipoHandicap === 34) {
            	toAppend = `${result.info1}, ${result.info2} / ${result.info4}`;
            } else {
                appender('/');
            }  	
        } else {
            if (tipoHandicap === 39) {
                toAppend = `${result.info1 / 100}, ${result.info2 / 100}`;
            } else {
                appender(' ');
            }
        }
    }
    
    if (desc === '') {
        return toAppend;
    } else {
        return `${desc} ${toAppend}`;
    }
}
